export enum HistoryActionTypes {
    GET_ACTIVITY = "[App Action][History] GET ACTIVITY LOGS",
    GET_ACTIVITY_SUCCESS = "[App Action][History] GET ACTIVITY LOGS SUCCESS",
    GET_ACTIVITY_FAIL = "[App Action][History] GET ACTIVITY LOGS FAIL",

    GET_HISTORY_USERS = "[App Action][History] GET HISTORY USERS",
    GET_HISTORY_USERS_SUCCESS = "[App Action][History] GET HISTORY USERS SUCCESS",
    GET_HISTORY_USERS_FAIL = "[App Action][History] GET HISTORY USERS FAIL"
}
